import React from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import Button from "../../button/Button";
import { ButtonTypeTokens, ButtonWidthTypeToken, ColorTokens, FontFamilyTokens, FontSizeTokens, TextAlignTokens } from '@voltmoney/schema';
import Typography from '../../typography/Typography';
const DigioFooter = ({ aadharInitAction, triggerAction, lenderInfo, lenderIcon, loading, onFooterPress, lenderName }) => {
    return (React.createElement(View, { style: styles.footer },
        React.createElement(View, { style: styles.buttonContainer, nativeID: 'bt_borrowerKyc_Proceed' },
            React.createElement(Button, { type: ButtonTypeTokens.LargeFilled, label: 'Proceed with DigiLocker', width: ButtonWidthTypeToken.FULL, fontSize: FontSizeTokens.SM, fontFamily: FontFamilyTokens.Inter, loading: loading, onPress: () => {
                    if (aadharInitAction) {
                        onFooterPress();
                        triggerAction(aadharInitAction);
                    }
                } })),
        React.createElement(View, { style: styles.footerTextContainer },
            React.createElement(Typography, { label: `By proceeding, I consent to share my KYC documents with ${lenderInfo?.lenderName} and consent to camera access for KYC completion.`, fontWeight: '400', lineHeight: 18, color: ColorTokens.Grey_Charcoal, fontSize: FontSizeTokens.XS, fontFamily: FontFamilyTokens.Inter, textAlign: TextAlignTokens.center }))));
};
const styles = StyleSheet.create({
    buttonContainer: {
        width: '100%',
        borderRadius: 1000,
        paddingTop: 16,
    },
    footer: Platform.OS === 'web' ? {
        position: 'absolute',
        bottom: 0,
        width: '100%',
        justifyContent: 'center',
        borderColor: '#E4E7EC',
        borderTopWidth: 1,
        borderBottomWidth: 0,
        paddingHorizontal: 16,
        shadowOpacity: 0.08,
        elevation: 10,
        backgroundColor: 'white',
        shadowOffset: {
            width: 0,
            height: -1,
        },
        shadowRadius: 5,
        alignItems: 'center',
        paddingBottom: 17,
        marginHorizontal: -16,
        left: 16,
        right: 16,
        shadowColor: '#D0D5DD',
    } : {
        alignItems: 'center',
        justifyContent: 'center',
        position: 'absolute',
        // paddingHorizontal:16,
        paddingBottom: 17,
        marginHorizontal: Platform.OS === "ios" ? 0 : -16,
        paddingHorizontal: 16,
        bottom: 0,
        left: Platform.OS === "ios" ? 0 : 16,
        right: Platform.OS === "ios" ? 0 : 16,
        backgroundColor: 'white',
        elevation: 10,
        shadowColor: '#D0D5DD',
        shadowOpacity: 0.5,
        shadowRadius: 5,
        marginTop: Platform.OS === "ios" ? 22 : 0,
        ...Platform.OS !== "ios" && {
            borderColor: '#F2F4F7',
            borderTopWidth: 0.5,
            borderBottomWidth: 0,
        },
    },
    footerTextContainer: {
        marginTop: 15,
    },
    partnerContainer: {
        flexDirection: 'row',
        marginTop: 16,
        alignItems: 'center'
    },
    partnerText: {
        marginRight: 9,
    },
    icon: {
        marginTop: 4,
    },
});
export default DigioFooter;
